import { render } from "./Tarea.vue?vue&type=template&id=a232c0f6&scoped=true"
import script from "./Tarea.vue?vue&type=script&lang=js"
export * from "./Tarea.vue?vue&type=script&lang=js"

import "./Tarea.vue?vue&type=style&index=0&id=a232c0f6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a232c0f6"]])

export default __exports__